<main class="main-home-secton">
    <div class="event-main">
        <div class="container">
            <div class="div-header">
                <h1>Contact Us</h1>
            </div>
            <div class="div-contents">
                <div class="row">
                    <div class="col-lg-8 col-md-8 col-sm-6 col-12">
                        <div class="contact-details-div">
                            <div class="d-flex">
                                <div class="mr-3">
                                    <ion-icon name="location-outline"></ion-icon>
                                </div>
                                <div>
                                    <p>Tamil Nadu Startup and Innovation Mission, </p>
                                    <p>Department of Micro, Small and Medium Enterprises, </p>
                                    <p>EDII Campus, Hindustan Teleprinters Staff Quarters, </p>
                                    <p>Parthasarathy Koil Street, SIDCO Industrial Estate, </p>
                                    <p>Guindy, Chennai - 600 032</p>
                                </div>
                            </div>
                            <div class="d-flex">
                                <div class="mr-3">
                                    <ion-icon name="call-outline"></ion-icon>
                                </div>
                                <div>
                                    <p>(+91) 44 22256789 </p>
                                </div>
                            </div>
                            <div class="d-flex">
                                <div class="mr-3">
                                    <ion-icon name="mail-outline"></ion-icon>
                                </div>
                                <div>
                                    <p>incubator@startuptn.com</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    
                    <div class="col-lg-4 col-md-4 col-sm-6 col-12">
                        <div class="text-center">
                            <img src="assets/images/contact-bg1.png" class="img-fluid" alt="">
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

</main>
<app-footer></app-footer>